
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../../framework/state';
import TextField from '../../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../../framework/fields/SelectField.vue';
import SwitchField from '../../../../../../framework/fields/SwitchField.vue';
import IntegerField from '../../../../../../framework/fields/IntegerField.vue';
import CurrencyAmountField from '../../../../../../framework/fields/CurrencyAmountField.vue';
import NumberField from '../../../../../../framework/fields/NumberField.vue';
import PercentageField from '../../../../../../framework/fields/PercentageField.vue';
import DateField from '../../../../../../framework/fields/DateField.vue';
import { ValidationObserver } from 'vee-validate';
import TextAreaField from '../../../../../../framework/fields/TextAreaField.vue';
import VendorContractSelect from '../../../../../fields/VendorContractSelect.vue';
import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import AutoCompleteField from '../../../../../../framework/fields/AutoCompleteField.vue';
import { getCustomerOptions } from '../../../../../service/application_options_service';
import { postDistributePurchaseInvoiceRows } from '../../../../../client/purchase_invoice_rows_distribute_client';
import { errorToast } from '../../../../../service/toast_service';

@Component({
    components: {
        VendorContractSelect,
        TextAreaField,
        DateField,
        PercentageField,
        NumberField,
        CurrencyAmountField,
        SelectField,
        TextField,
        SwitchField,
        IntegerField,
        ValidationObserver,
        AutoCompleteField,
    },
})
export default class DistributePurchaseInvoiceRows extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.PURCHASE_INVOICE_ROW;

    // Properties
    @Prop(String) readonly purchaseInvoiceRowIds!: string;

    // State
    shared = sharedState;
    local = {
        customerId: undefined as string | undefined,
        customerOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.customerOptions = await getCustomerOptions();
    }

    async save() {
        try {
            await postDistributePurchaseInvoiceRows({
                customerId: this.local.customerId!,
                purchaseInvoiceRowIds: this.purchaseInvoiceRowIds.split(','),
            });
            this.back();
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
